let storage;

try {
  const testKey = '@@test-storage';
  window.localStorage.setItem(testKey, 'test');
  window.localStorage.removeItem(testKey);
  storage = window.localStorage;
} catch (e) {
  console.warn('LocalStorage is not available. Using in-memory storage. Data will be lost on page refresh.');

  const memoryStore = {};

  storage = {
    getItem: (key) => memoryStore[key] || null,
    setItem: (key, value) => {
      memoryStore[key] = String(value);
    },
    removeItem: (key) => {
      delete memoryStore[key];
    },
    clear: () => {
      for (const key in memoryStore) {
        if (Object.prototype.hasOwnProperty.call(memoryStore, key)) {
          delete memoryStore[key];
        }
      }
    },
  };
}

export default storage;
